import axios from 'axios';

import {
  GET_QUESTIONS,
  GET_QUESTION,
  ADD_QUESTION,
  DELETE_QUESTION,
  EDIT_QUESTION,
  QUESTION_LOADING,
  GET_ERRORS,
  CLEAR_ERRORS,
  QUESTION_BANK
} from './types';

// Add Word
export const addQuestion = question => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/question/add', question)
    .then(res =>
      dispatch({
        type: ADD_QUESTION,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Get Posts
export const getQuestions = () => dispatch => {
  dispatch(setQuestionLoading());
  axios
    .get('/api/question')
    .then(res =>
      {
        dispatch({
          type: GET_QUESTIONS,
          payload: res.data
        })
      }
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: null
      })
    );
};

export const questionBank = () => dispatch => {
  dispatch(setQuestionLoading());
  axios
    .get('/api/question/list')
    .then(res =>
      {
        dispatch({
          type: QUESTION_BANK,
          payload: res.data
        })
      }
    );
};

// Get Word
export const getQuestion = id => dispatch => {
  dispatch(setQuestionLoading());
  axios
    .get(`/api/question/get_by_id/${id}`)
    .then(res =>
      dispatch({
        type: GET_QUESTIONS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: null
      })
    );
};

export const removeQuestion = (id) => {
  return axios.delete(`/api/question/${id}`); 
}

// Delete Post
export const deleteQuestion = id => dispatch => {
  axios
    .delete(`/api/question/${id}`)
    .then(res =>
      dispatch({
        type: DELETE_QUESTION,
        payload: id
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const saveOrUpdate = (data) => {
  if (data._id) {
    return axios.post('/api/question/update', data); 
  }
  return axios.post('/api/question/add', data);
}

// Set loading state
export const setQuestionLoading = () => {
  return {
    type: QUESTION_LOADING
  };
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
